import { render, staticRenderFns } from "./BrokerClubs.vue?vue&type=template&id=72c8dc0c&scoped=true"
import script from "./BrokerClubs.vue?vue&type=script&lang=js"
export * from "./BrokerClubs.vue?vue&type=script&lang=js"
import style0 from "./BrokerClubs.vue?vue&type=style&index=0&id=72c8dc0c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72c8dc0c",
  null
  
)

export default component.exports